import { memo, useCallback } from "react";
import { SimpleSelect, SimpleSelectProps } from "../../SimpleSelect";
import { UNITS } from "../constants";
import { formatValue } from "../converter";
import { ClockFormat, LeadingZero, Locale } from "../types";
import { useCronFieldProps } from "./utils";

export type HoursProps = Omit<SimpleSelectProps<number>, "onChange" | "options"> & {
  locale: Locale
  onChange?: ((newValue: number[]) => void) | undefined
  leadingZero: LeadingZero
  clockFormat?: ClockFormat
};

export const Hours = memo((
  {
    locale,
    leadingZero,
    clockFormat,
    ...props
  }: HoursProps) => {
  const unit = UNITS.find(x => x.type === "hours")!;
  const { options, onChange, isMulti } = useCronFieldProps(
    props.value,
    props.onChange,
    props.isMulti ?? false,
    unit,
  );

  const setOptionLabel = useCallback((v: number) => formatValue(v, unit, undefined, leadingZero, clockFormat),
    [ leadingZero, clockFormat, unit ]);

  return (
    <div>
      {locale.prefixHours !== "" && (
        <span>{locale.prefixHours}</span>
      )}

      <SimpleSelect
        placeholder={locale.emptyHours}
        isClearable
        isSearchable
        {...props}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        setOptionLabel={setOptionLabel}
      />
    </div>
  );
});
